import QuoteIcons from '../../../scenes/Quote/scenes/Components/Icon/QuoteIcons';
import * as React from 'react';
import { HelpBlock } from 'react-bootstrap';

export const ErrorDisplay = ({ error }) => {
  const icon = (<QuoteIcons color={'warning'} name={'Warning'}/>)

  if (error) {
    return (
      <HelpBlock>
        <div className={'error-container'}>
          <div className={'error-icon'}>{icon}</div>
          <div className={'error-text'}>{error}</div>
        </div>
      </HelpBlock>
    )
  }

  return null;
}
